export default __webpack_public_path__ + "static/media/oasis.e73c9c39.jpg";